/**
 * Attempts to coerce a value to a number. If parsing fails, returns the original value.
 *
 * @param val - The value to convert.
 * @returns The parsed number or the original value if conversion is not possible.
 */
export const looseToNumber = <T>(val: T): number | T => {
  const n = Number.parseFloat(String(val));
  return Number.isNaN(n) ? val : n;
};
